import {
  animate,
  AnimationTriggerMetadata,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const dropdownSlide: AnimationTriggerMetadata = trigger(
  'dropdownSlide',
  [
    state(
      'void',
      style({
        height: 0,
        transform: 'scaleY(0.8)',
      }),
    ),
    state(
      'enter',
      style({
        height: '*',
        transform: 'scaleY(1)',
      }),
    ),
    transition('void => *', [animate('150ms ease-in-out')]),
    transition('* => void', [animate('150ms ease-in-out')]),
  ],
);
